import { render, staticRenderFns } from "./myinf.vue?vue&type=template&id=02182b4f&scoped=true&"
import script from "./myinf.vue?vue&type=script&lang=js&"
export * from "./myinf.vue?vue&type=script&lang=js&"
import style0 from "./myinf.vue?vue&type=style&index=0&id=02182b4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02182b4f",
  null
  
)

export default component.exports